export default "__VITE_ASSET__QPr8fbK1__"